import { get, put } from '@api/api-client';
import { type PaginatedResponse, type PaginationParams } from '@api/pagination';

export interface ParticipantResponse {
  id: string;
  name: string;
  surname: string | null;
  photoUrl: string | null;
  profileUrl: string | null;
  city: string | null;
  dpDoctorId: number;
  countryId: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateParticipantDTO {
  name?: string;
  surname?: string | null;
  photoUrl?: string | null;
  profileUrl?: string | null;
  city?: string | null;
  dpDoctorId?: number;
}

interface ParticipantListParams extends PaginationParams {
  search?: string;
  /** Restricts the listing to one site; required when picking edition nominees. */
  siteId?: string;
}

/** Fetches participants with pagination and optional search. */
export function getParticipants(
  params?: ParticipantListParams,
): Promise<PaginatedResponse<ParticipantResponse>> {
  let path = '/participants';
  const queryParts: string[] = [];

  if (params?.page !== undefined) queryParts.push(`page=${params.page}`);
  if (params?.pageSize !== undefined) queryParts.push(`pageSize=${params.pageSize}`);
  if (params?.search) queryParts.push(`search=${encodeURIComponent(params.search)}`);
  if (params?.siteId) queryParts.push(`siteId=${encodeURIComponent(params.siteId)}`);

  if (queryParts.length > 0) path += `?${queryParts.join('&')}`;

  return get<PaginatedResponse<ParticipantResponse>>(path);
}

/** Updates an existing participant by ID. */
export function updateParticipant(
  id: string,
  data: UpdateParticipantDTO,
): Promise<ParticipantResponse> {
  return put<ParticipantResponse>(`/participants/${id}`, data);
}
